'use client';

import { useState } from 'react';

interface Region {
  id: string;
  name: string;
  specialty: string;
}

const gangwonRegions: Region[] = [
  { 
    id: '춘천시', 
    name: '춘천시', 
    specialty: '닭갈비, 막국수, 감자빵, 흑초, 블루베리, 총떡, 민물고기 요리' 
  },
  { 
    id: '원주시', 
    name: '원주시', 
    specialty: '치악산 배, 치악산 사과, 치악산 복숭아, 원주 토토미(쌀), 치악산 한우' 
  },
  { 
    id: '강릉시', 
    name: '강릉시', 
    specialty: '감자옹심이, 초당순두부, 짬뽕빵, 강릉샌드, 막국수, 무지개송어회' 
  },
  { 
    id: '동해시', 
    name: '동해시', 
    specialty: '해산물(오징어, 대게, 쥐포), 곰치국, 곰취, 사과, 옥수수' 
  },
  { 
    id: '태백시', 
    name: '태백시', 
    specialty: '곰취찐빵, 곰취 산채냉면, 산죽차, 산채 송편' 
  },
  { 
    id: '속초시', 
    name: '속초시', 
    specialty: '아바이순대, 오징어순대, 닭강정, 해산물, 젓갈류' 
  },
  { 
    id: '삼척시', 
    name: '삼척시', 
    specialty: '원덕왕마늘, 가시오가피, 삼척 대게, 삼척 곰치국, 물닭갈비' 
  },
  { 
    id: '철원군', 
    name: '철원군', 
    specialty: '오대쌀, 토마토, 흑마늘, 쿨포크, 막걸리, 메밀' 
  },
  { 
    id: '화천군', 
    name: '화천군', 
    specialty: '산천어, 토마토, 잣, 상황버섯, 노루궁뎅이버섯, 가시오가피' 
  },
  { 
    id: '양구군', 
    name: '양구군', 
    specialty: '시래기, 오대쌀, 멜론, 아스파라거스, 곰취, 사과, 포도' 
  },
  { 
    id: '인제군', 
    name: '인제군', 
    specialty: '황태, 오미자, 곰취, 블루베리, 고로쇠 수액, 명이나물' 
  },
  { 
    id: '고성군', 
    name: '고성군', 
    specialty: '도로묵, 명태, 대게, 털게, 오징어, 양미리, 갯장어, 왕새우' 
  },
  { 
    id: '양양군', 
    name: '양양군', 
    specialty: '연어, 송이버섯, 오징어, 삼치, 고등어, 대왕문어, 황태' 
  },
  { 
    id: '홍천군', 
    name: '홍천군', 
    specialty: '홍천한우, 홍천잣, 홍천 인삼, 홍천 쌀, 찰옥수수, 산양삼' 
  },
  { 
    id: '횡성군', 
    name: '횡성군', 
    specialty: '횡성한우, 더덕, 토마토, 안흥찐빵, 어사진미, 절임배추' 
  },
  { 
    id: '평창군', 
    name: '평창군', 
    specialty: '배추, 감자, 메밀, 옥수수, 대관령 한우, 평창 송어' 
  },
  { 
    id: '정선군', 
    name: '정선군', 
    specialty: '곤드레, 취나물, 어수리, 곤드레밥, 메밀전병, 올챙이국수' 
  },
  { 
    id: '영월군', 
    name: '영월군', 
    specialty: '사과, 포도, 고추장, 더덕술, 한우, 토마토, 느타리버섯' 
  },
];

export function GangwonMap() {
  const [selectedRegion, setSelectedRegion] = useState<string>('춘천시');

  const handleRegionClick = (regionId: string) => {
    setSelectedRegion(regionId);
  };

  return (
    <div className="w-full max-w-4xl mx-auto mt-4">
      <div className="relative bg-white rounded-2xl shadow-lg overflow-hidden">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 509 300"
          className="w-full h-auto min-h-[250px] md:min-h-[350px]"
          style={{ background: '#f8fafc' }}
        >
          <style>
            {`
              .region-path {
                fill: #e2e8f0;
                stroke: #475569;
                stroke-width: 1;
                transition: all 0.3s ease-in-out;
                cursor: pointer;
              }
              .region-path:hover {
                fill: #cbd5e1;
                stroke: #334155;
                stroke-width: 1.5;
              }
              .region-path.selected {
                fill: #10b981;
                stroke: #059669;
                stroke-width: 2;
              }
              .region-text {
                fill: #1f2937;
                font-size: 11px;
                font-weight: 600;
                pointer-events: none;
                text-anchor: middle;
              }
            `}
          </style>
          <g id="강원도" transform="translate(-41, 9)">
            <path
              id="양양군"
              className={`region-path ${selectedRegion === '양양군' ? 'selected' : ''}`}
              d="M342.9,115.8 L340.9,107 L346.6,96.9 L343.2,90.6 L335.7,91.4 L333,84.1 L340.4,80.4 L358.1,73.7 L383.4,111.5 L380.6,112.1 L375.8,112.7 L375.7,113.1 L375.7,113.1 L372.3,113.9 L372.3,113.8 L362.9,115.2 L356.1,120.5 L354.3,120 L350.2,116 Z"
              onClick={() => handleRegionClick('양양군')}
            />
            <text x="360" y="95" className="region-text">양양</text>
            
            <path
              id="고성군"
              className={`region-path ${selectedRegion === '고성군' ? 'selected' : ''}`}
              d="M315.8,46.1l5.3,1.2l1.1,10.3l4.9,0l1.2,4.7l6.9-2.8l2.2,7.7l4.8,2.5l12.7-6.6l-16.1-31.5 l-5.8-19.4l-5.1-5.7l-1.5-3l-5.1,4.8l-5.5,32.1L315.8,46.1z"
              onClick={() => handleRegionClick('고성군')}
            />
            <text x="335" y="40" className="region-text">고성</text>
            
            <path
              id="인제군"
              className={`region-path ${selectedRegion === '인제군' ? 'selected' : ''}`}
              d="M282.5,108.7 L281.1,101.2 L286.7,97.2 L290.6,97.1 L290.6,92.1 L297.1,93.6 L297,88.3 L293.9,84.4 L296,82.4 L293.6,75.6 L298.2,61.7 L302.7,57.3 L303.9,50 L306.7,42.8 L315.8,40.3 L315.8,46.1 L321.1,47.3 L322.2,57.6 L327.2,57.6 L328.4,62.3 L335.3,59.5 L337.5,67.2 L334.9,71.5 L340.4,80.4 L333,84.1 L335.7,91.4 L343.2,90.6 L346.6,96.9 L340.9,107 L342.9,115.8 L338.3,120.2 L334.6,117 L333.1,119.9 L326.3,126.4 L319.9,119.8 L309.1,128.6 L303.1,115.8 L294.6,115.4 L286.9,108.2 Z"
              onClick={() => handleRegionClick('인제군')}
            />
            <text x="315" y="85" className="region-text">인제</text>
            
            <path
              id="양구군"
              className={`region-path ${selectedRegion === '양구군' ? 'selected' : ''}`}
              d="M284.8,54.1l8.6-0.1l3.3-5.9l7.1,1.8l-1.1,7.3l-4.5,4.5l-4.6,13.9l2.3,6.8l-2.1,2l3.1,3.8 l0.1,5.3l-6.5-1.6l0,5.1l-3.8,0.1l-2.1-0.7l-2.4,2.7l-4.7-5.8l-2.6,3.9l-4-5.7l-3.1-23l-3.3-1.7L266,55l4.2-4.4l13,5.8L284.8,54.1z"
              onClick={() => handleRegionClick('양구군')}
            />
            <text x="280" y="75" className="region-text">양구</text>
            
            <path
              id="화천군"
              className={`region-path ${selectedRegion === '화천군' ? 'selected' : ''}`}
              d="M260.4,54.5l2.8,0.2l2.9,0.6l-1.4,11.5l3.3,1.7l3.1,23l-5.9-0.2l-0.2,0.3l0.6,5l-3.8,2.8 l-4.8,1l-5.2-7.1l-2.9,2.3l-2.9-2.1l-5.7,2.3l-0.3-4.8l-9.7-4.8l0.6,7.1l-4.8,6.1l-8.5-0.9l-3.1-7l-1.9-10l0,0l8-2.8l1.6-10.3 l11.1-13l13.1,5.4l3.5-4.8l9.7-1.5L260.4,54.5z"
              onClick={() => handleRegionClick('화천군')}
            />
            <text x="245" y="75" className="region-text">화천</text>
            
            <path
              id="철원군"
              className={`region-path ${selectedRegion === '철원군' ? 'selected' : ''}`}
              d="M184.6,49.9l-2.6,1l-5.7-0.6l-4.1,6.5l2.8,6.2l4.6-0.7l2.1,8.2l5.4,7.1l7.3-6.6l-0.9,9.2 l7.5,5.4l5.2-4.5l3.3,2.4l3.1-1.9l8-2.8l1.6-10.3l11.1-13l13.1,5.4l3.5-4.8l9.7-1.5l-6.3-5.6l-5.6,2.1L232,46.9l-11.2,5.9 l-14.2-5.9l-3.5,5.2l-6.7,0.4l-0.1-3.4l-7.3-1.5L184.6,49.9L184.6,49.9z"
              onClick={() => handleRegionClick('철원군')}
            />
            <text x="210" y="65" className="region-text">철원</text>
            
            <path
              id="정선군"
              className={`region-path ${selectedRegion === '정선군' ? 'selected' : ''}`}
              d="M358.2,211.5 L350.8,192.8 L346.7,190.2 L347.6,184.1 L353.8,183.2 L353.9,176.7 L356.4,179.1 L358.3,166.2 L361.3,165.6 L362.6,170.8 L368,166 L373.1,172.4 L375.3,169.4 L382,170.6 L384.9,176.2 L389.3,174.2 L393.5,162.1 L396.3,168.3 L404.7,171.2 L403.5,174.1 L403.4,174.2 L406.9,178.8 L403,184.8 L396.2,186.3 L389.3,201.7 L393.4,204.1 L390.9,207.3 L397.3,220.9 L396.5,231.8 L378.1,221.9 L364.1,226.7 L361.2,221 L356.1,220.9 L355.7,213.3 Z"
              onClick={() => handleRegionClick('정선군')}
            />
            <text x="375" y="195" className="region-text">정선</text>
            
            <path
              id="삼척시"
              className={`region-path ${selectedRegion === '삼척시' ? 'selected' : ''}`}
              d="M431.5,182.8l1.5,6.4l7.5,5.3l1.5,8.9l11.3,13.5l-1.9,6.6l3.1,7.3l-8.1,3.5l-9,8.1l1.7,5.5 l-6.6-0.4l-11.4-9l0,0l-1-9l-11.1-6.8l-1.4-6l3.4-9.8l-2.7-5.3l-3.6,0.2l-7.4,18.9l0,0l-6.4-13.6l2.4-3.1l-4.1-2.4l6.9-15.4 l6.8-1.5l5.9,3l6.3-5.1l10.3-0.8l0,0l2.7-2.1L431.5,182.8z"
              onClick={() => handleRegionClick('삼척시')}
            />
            <text x="425" y="210" className="region-text">삼척</text>
            
            <path
              id="속초시"
              className={`region-path ${selectedRegion === '속초시' ? 'selected' : ''}`}
              d="M355.1,62.8l3,10.9l-17.7,6.7l-5.5-8.9l2.6-4.3l4.8,2.5L355.1,62.8z"
              onClick={() => handleRegionClick('속초시')}
            />
            <text x="348" y="71" className="region-text">속초</text>
            
            <path
              id="동해시"
              className={`region-path ${selectedRegion === '동해시' ? 'selected' : ''}`}
              d="M426.2,176.6l2,3.2l-2.7,2.1l0,0l-10.3,0.8l-6.3,5.1l-5.9-3l3.9-6l-3.5-4.6l0.1-0.1l1.2-3 l9.1-2.2l1.3-7.9l0.1,0l1.4-0.6l0-0.1l5.5,2.9l0,7l4.6,6.1L426.2,176.6z"
              onClick={() => handleRegionClick('동해시')}
            />
            <text x="415" y="175" className="region-text">동해</text>
            
            <path
              id="강릉시"
              className={`region-path ${selectedRegion === '강릉시' ? 'selected' : ''}`}
              d="M375.1,159.7l-0.5-7.1l3.9-2.9l-2.8-10.7l-5.7-4.6l-11.9,0.5l-0.4-6.2l-2.2-1.9l0.6-6.4l6.7-5.2l9.4-1.4l0,0.1l3.4-0.8l0-0.1l0.1-0.3l4.8-0.6l2.8-0.6l31.1,37.4l-0.8,4l3,7.5l0,0.1l-1.4,0.6l-0.1,0l-1.3,7.9l-9.1,2.2l-8.5-2.8l-2.7-6.3l-4.2,12.2l-4.4,2l-2.9-5.6l-6.6-1.2l-2.2,3L368,166l0.6-3.8L375.1,159.7z"
              onClick={() => handleRegionClick('강릉시')}
            />
            <text x="385" y="145" className="region-text">강릉</text>
            
            <path
              id="평창군"
              className={`region-path ${selectedRegion === '평창군' ? 'selected' : ''}`}
              d="M355.5,126.8 L357.7,128.8 L358.1,134.9 L370,134.5 L375.7,139.1 L378.5,149.8 L374.6,152.6 L375.1,159.7 L368.6,162.3 L368,166 L362.6,170.8 L361.3,165.6 L358.3,166.2 L356.4,179.1 L353.9,176.7 L353.8,183.2 L347.6,184.1 L346.7,190.2 L350.8,192.8 L358.2,211.5 L358.2,211.5 L355.7,213.4 L351.5,210.6 L348.4,210.4 L336.7,201.9 L334.8,209.4 L330.4,210.1 L324.2,205.4 L324.3,196.5 L316.7,191.8 L313.9,180.7 L321.1,171.5 L318.6,158.6 L315,157.6 L322.2,145.6 L335,147.9 L340.2,141.2 L348.7,140.9 L350.7,130.2 Z"
              onClick={() => handleRegionClick('평창군')}
            />
            <text x="345" y="170" className="region-text">평창</text>
            
            <path
              id="영월군"
              className={`region-path ${selectedRegion === '영월군' ? 'selected' : ''}`}
              d="M316.7,191.8 L324.3,196.5 L324.2,205.4 L330.4,210.1 L334.8,209.4 L336.7,201.9 L336.7,201.9 L348.3,210.4 L348.4,210.4 L351.5,210.6 L351.5,210.6 L355.7,213.3 L355.7,213.3 L356.1,220.9 L361.2,221 L364.1,226.7 L378.1,221.9 L378.1,221.9 L396.5,231.8 L392.5,237.8 L395,238.9 L393.7,243.6 L398,244.1 L396.3,247.8 L394,246.5 L393.3,248 L381.6,240.5 L378.4,250.7 L372.8,248.9 L365.6,245 L365.6,245 L361.9,241.6 L351.3,241.3 L346,235.7 L337,239.5 L331.9,230.8 L321.2,234.7 L316.9,230.6 L321.1,228.8 L325.4,221.9 L323.3,220.7 L317.3,223.2 L309.7,216.8 L308.3,209.3 L301.5,213.4 L298.1,213.2 L297.2,209.1 L298.4,205.1 L304.4,205.5 L306.8,202.5 L306.7,194.3 L313.1,195 Z"
              onClick={() => handleRegionClick('영월군')}
            />
            <text x="340" y="225" className="region-text">영월</text>
            
            <path
              id="횡성군"
              className={`region-path ${selectedRegion === '횡성군' ? 'selected' : ''}`}
              d="M258.7,187.4 L258.6,182.1 L253.6,177.3 L264.5,169.6 L264.5,169.6 L279.8,156.1 L285.9,160 L297.6,153.4 L298.1,149.7 L315,157.6 L318.6,158.6 L321.1,171.5 L313.9,180.7 L316.7,191.8 L313.1,195 L306.7,194.3 L306.8,202.5 L304.4,205.5 L298.4,205.1 L297.2,209.1 L290.2,207.6 L287.9,203.9 L295.7,192.3 L294.1,189.1 L277.2,184.9 L274.7,176.7 L268.2,182.9 L267,193.6 L261.2,186.2 Z"
              onClick={() => handleRegionClick('횡성군')}
            />
            <text x="285" y="180" className="region-text">횡성</text>
            
            <path
              id="홍천군"
              className={`region-path ${selectedRegion === '홍천군' ? 'selected' : ''}`}
              d="M282.5,108.7 L286.9,108.2 L294.6,115.4 L303.1,115.8 L309.1,128.6 L319.9,119.8 L326.3,126.4 L333.1,119.9 L334.6,117 L338.3,120.2 L342.9,115.8 L350.2,116 L354.3,120 L356.1,120.5 L355.5,126.8 L350.7,130.2 L348.7,140.9 L340.2,141.2 L335,147.9 L322.2,145.6 L315,157.6 L298.1,149.7 L297.6,153.4 L285.9,160 L279.8,156.1 L264.5,169.6 L258.2,164.7 L247.1,164.3 L234.3,154.2 L228.6,157.8 L225.6,154.8 L228.6,142.1 L232.8,143.3 L234.8,150.4 L238.1,146.8 L239.5,149.8 L251.4,140 L262.5,140 L265.6,135.8 L262.2,131.8 L262.2,131.8 L260.1,125.6 L267.3,125 L269.7,121 L274.9,126.7 Z"
              onClick={() => handleRegionClick('홍천군')}
            />
            <text x="290" y="140" className="region-text">홍천</text>
            
            <path
              id="태백시"
              className={`region-path ${selectedRegion === '태백시' ? 'selected' : ''}`}
              d="M408.3,201.8 L410.9,207.1 L407.5,216.9 L409,222.9 L420.1,229.7 L421.1,238.7 L416.7,244.2 L404.1,242.5 L402.3,240 L399.3,240.4 L398,244.1 L393.7,243.6 L395,238.9 L392.5,237.8 L396.5,231.8 L397.3,220.9 L404.7,201.9 Z"
              onClick={() => handleRegionClick('태백시')}
            />
            <text x="405" y="225" className="region-text">태백</text>
            
            <path
              id="원주시"
              className={`region-path ${selectedRegion === '원주시' ? 'selected' : ''}`}
              d="M258.7,187.4 L261.2,186.2 L267,193.6 L268.2,182.9 L274.7,176.7 L277.2,184.9 L294.1,189.1 L295.7,192.3 L287.9,203.9 L290.2,207.6 L297.2,209.1 L298.1,213.2 L301.5,213.4 L308.3,209.3 L309.7,216.8 L304.3,222.4 L299.4,219.1 L297.3,223.7 L288.9,226.3 L286,217.5 L280.2,215.8 L274,220.6 L274.6,230.1 L272.3,229.8 L271.1,232.5 L267.8,230.3 L257.4,233.6 L251.9,222.6 L252,222.4 L252.2,217.9 L253.6,198.6 Z"
              onClick={() => handleRegionClick('원주시')}
            />
            <text x="280" y="210" className="region-text">원주</text>
            
            <path
              id="춘천시"
              className={`region-path ${selectedRegion === '춘천시' ? 'selected' : ''}`}
              d="M282.5,108.7 L274.9,126.7 L269.7,121 L267.3,125 L260.1,125.6 L262.2,131.8 L262.2,131.8 L265.6,135.8 L262.5,140 L251.4,140 L239.5,149.8 L238.1,146.8 L234.8,150.4 L232.8,143.3 L228.6,142.1 L222.1,143.4 L226.8,137.2 L223.8,132.1 L224.4,125.8 L234.3,119 L235.6,110.9 L233.6,106.4 L226.8,104.7 L226.2,99.6 L230.9,93.4 L230.3,86.4 L240,91.1 L240.3,95.9 L246,93.7 L248.8,95.8 L251.7,93.4 L256.9,100.5 L261.7,99.5 L265.5,96.6 L264.9,91.7 L265.1,91.4 L271,91.6 L275,97.4 L277.5,93.5 L282.3,99.2 L284.7,96.5 L286.7,97.2 L281.1,101.2 Z"
              onClick={() => handleRegionClick('춘천시')}
            />
            <text x="255" y="115" className="region-text">춘천</text>
          </g>
        </svg>

        {/* 강원특별자치도 타이틀 */}
        <div className="absolute top-4 left-4 z-20">
          <div className="bg-gradient-to-r from-green-600 to-blue-600 text-white px-4 py-2 rounded-lg shadow-lg">
            <span className="text-lg md:text-xl font-bold tracking-wide">강원특별자치도</span>
          </div>
        </div>

        {/* 지역 정보 패널 */}
        {selectedRegion && (
          <div className="p-3 md:p-4 pb-4 md:pb-6 bg-gradient-to-r from-blue-50 to-green-50 rounded-xl border border-blue-100 shadow-lg mt-2 mx-2 md:mx-4 mb-4 md:mb-6 relative z-10">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-r from-blue-500 to-green-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-base md:text-lg">
                  {gangwonRegions.find(region => region.id === selectedRegion)?.name[0]}
                </span>
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900">
                  {gangwonRegions.find(region => region.id === selectedRegion)?.name}
                </h3>
                <p className="text-gray-600 text-sm">강원도 대표 특산품</p>
              </div>
            </div>
            
            <div className="bg-white rounded-lg p-3 md:p-4 border border-gray-100">
              <h4 className="font-semibold text-gray-800 mb-2 text-sm md:text-base">🏷️ 주요 특산품</h4>
              <div className="flex flex-wrap gap-1.5 md:gap-2">
                {gangwonRegions.find(region => region.id === selectedRegion)?.specialty
                  .split(', ')
                  .map((item, index) => (
                    <span 
                      key={index}
                      className="px-2 py-1 md:px-3 md:py-1 bg-gradient-to-r from-green-100 to-blue-100 text-green-800 text-xs md:text-sm rounded-full border border-green-200"
                    >
                      {item.trim()}
                    </span>
                  ))
                }
              </div>
            </div>
            
            <div className="mt-3 text-center">
              <button 
                onClick={() => setSelectedRegion('춘천시')}
                className="px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800 transition-colors"
              >
                기본 선택 (춘천시) ↺
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}